import React from 'react';
import { CheckIcon } from 'lucide-react';
import { HOW_IT_WORKS } from '../lib/content';
import { Reveal } from './Reveal';
export function HowItWorks() {
  return <section className="w-full bg-[#0F2A55] py-16 sm:py-24" data-id="element-213" data-mp="7qiq9n7qqu9o">
      <div className="mx-auto w-full max-w-2xl px-5 sm:px-8" data-id="element-214" data-mp="3pzt95ug9yt60">
        <Reveal className="text-center" data-id="element-215" data-mp="3tzjx7qef2v6u">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-4 py-1.5 font-display text-[10px] font-black uppercase tracking-widest text-[#FF6B35] shadow-sm sm:text-xs" data-id="element-216" data-mp="3u0lkct8pj84x">
            {HOW_IT_WORKS.badge}
          </span>
          <h2 className="mt-6 font-black text-white sm:text-5xl font-[Barlow,_sans-serif] text-[28px]" data-id="element-217" data-mp="crye1n1azevr">
            {HOW_IT_WORKS.title}
          </h2>
          <p className="mt-4 text-[15px] font-bold leading-snug text-white sm:text-lg" data-id="element-218" data-mp="gs0ddpjkfw7v">
            {HOW_IT_WORKS.description}
          </p>
        </Reveal>

        <div className="mt-10 flex flex-col gap-3" data-id="element-219" data-mp="19ae2n0qu69vc">
          {HOW_IT_WORKS.steps.map((step, i) => <Reveal key={step.number} delay={i * 0.1} float={true} data-id="element-220" data-mp="2rl4s0ujyrp07" data-mpi={i}>
              <div className="flex items-center gap-4 rounded-[20px] bg-white p-4 shadow-sm sm:p-5" data-id="element-221" data-mp="2rjbgb0uhuelc">
                <span className="flex h-12 w-12 flex-none items-center justify-center rounded-[14px] bg-[#F0F4FF] font-display text-xl font-black text-[#1C3587] sm:h-14 sm:w-14 sm:text-2xl" data-id="element-222" data-mp="2mkqjzcid4f26">
                  {step.number}
                </span>
                <div className="flex-1 text-left" data-id="element-223" data-mp="3ab4ed9of6pzx">
                  <span className="inline-flex rounded-full bg-[#FF6B35] px-3 py-1 font-display text-[13px] font-black text-white shadow-sm sm:text-sm" data-id="element-224" data-mp="3ae07mkpboqi1">
                    {step.title}
                  </span>
                  <p className="mt-1.5 text-[12px] font-bold leading-tight text-[#4A5568] sm:text-sm" data-id="element-225" data-mp="3fbi95q10g3g0">
                    {step.description}
                  </p>
                </div>
              </div>
            </Reveal>)}
        </div>

        <Reveal className="mt-4" delay={0.3} data-id="element-226" data-mp="1kyseh62tiq7k">
          <div className="flex items-center gap-4 rounded-[20px] bg-[#E6F4EA] p-5 shadow-sm sm:p-6" data-id="element-227" data-mp="3kzqmmzfvbv21">
            <div className="flex h-12 w-12 flex-none items-center justify-center rounded-full bg-[#22C55E] text-white shadow-sm sm:h-14 sm:w-14" data-id="element-228" data-mp="3pya9r3677cvz">
              <CheckIcon className="h-6 w-6 sm:h-7 sm:w-7" strokeWidth={4} data-id="element-229" data-mp="3tylt8cmtr75v" />
            </div>
            <div className="flex-1 text-left" data-id="element-230" data-mp="2uncv1eyiuva">
              <h3 className="font-display text-[9px] font-black uppercase tracking-widest text-[#166534] sm:text-[10px]" data-id="element-231" data-mp="7symbb1cb3cz">
                {HOW_IT_WORKS.result.title.replace('✓ ', '')}
              </h3>
              <p className="mt-0.5 font-display text-lg font-black leading-tight text-[#064E3B] sm:text-xl" data-id="element-232" data-mp="hiqoaqbrqyrh">
                {HOW_IT_WORKS.result.description}
              </p>
              <p className="mt-1 text-[11px] font-bold leading-tight text-[#166534] sm:text-xs" data-id="element-233" data-mp="lmg4aredo80w">
                {HOW_IT_WORKS.result.subtitle}
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}